import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "OrdenDeMeritoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "OrdenDeMeritoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexOrdenDeMerito(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Persona', name: 'Persona', title: 'Persona' },
                { data: 'OrdenDeMerito', name: 'OrdenDeMerito', title: 'Orden de Merito' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                { data: 'Curso', name: 'Curso', title: 'Curso' },
                { data: 'Unidad', name: 'Unidad', title: 'Unidad' },
                { data: 'TipoDocumento', name: 'TipoDocumento', title: 'Tipo Documento' },
                { data: 'NroDocumento', name: 'NroDocumento', title: 'NroDocumento' },
                { data: 'FechaInicio', name: 'FechaInicio', title: 'Fecha Inicio' },
                { data: 'FechaFin', name: 'FechaFin', title: 'Fecha Fin' },
                { data: 'EstadoDocumento', name: 'EstadoDocumento', title: 'Estado Documento' },
                { data: 'Promedio', name: 'Promedio', title: 'Promedio' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            ordendemeritos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            ordendemerito: {},
            
        };
    },
    methods: {
      
        
        newOrdenDeMerito() {
            this.ordendemerito = {};
            this.$refs['frm-ordendemerito'].show();
            // console.log("hhhhola")
        },
        showOrdenDeMerito(id) {
            this.isLoading=true;
            this.ss.showOrdenDeMerito(id).then(
                (result) => {
                    let response = result.data;
                    this.ordendemerito = response.data;
                    this.$refs['view-ordendemerito'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editOrdenDeMerito() {
            this.$refs['frm-ordendemerito'].show();
            this.$refs['view-ordendemerito'].hide();
        },
        cancelOrdenDeMerito() {
            if (this.ordendemerito.id) {
                this.$refs['view-ordendemerito'].show();
            }
            this.$refs['frm-ordendemerito'].hide();
        },
        saveOrdenDeMerito() {
            this.ss.storeOrdenDeMerito(this.ordendemerito).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-ordendemerito'].hide();
                    this.$refs['datatable-ordendemerito'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteOrdenDeMerito() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyOrdenDeMerito(this.ordendemerito)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-ordendemerito'].hide();
                                this.$refs['datatable-ordendemerito'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-ordendemerito'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-ordendemerito'].show();
        },
        changePassword() {
            this.password.OrdenDeMerito = this.ordendemerito.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-ordendemerito'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-OrdenDeMerito').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showOrdenDeMerito(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
